import React from 'react';
import PropTypes from 'prop-types';

/**
 * Component rendered when the application state is ERROR.
 *
 * @params see propTypes
 * @returns {JSX.Element}
 * @component
 */
const ApplicationError = ({ error }) => {
  return (
    <div className="l-section__content-wrapper align-items-center mt-12 pt-0 pb-10 pb-md-20 px-md-20">
      {error}
    </div>
  );
};

ApplicationError.propTypes = {
  error: PropTypes.element
};

ApplicationError.defaultProps = {
  error: (
    <>
      <p>An error occurred. Please try again later. </p>
    </>
  )
};

export default ApplicationError;
